import type { JSX } from "react";

import { default as Tile } from "../Tile";
import { default as TileContentText } from "./TileContentText";

const StatTile = ({
  title,
  content,
}: {
  title: string | JSX.Element;
  content: string;
}) => <Tile title={title} content={<TileContentText text={content} />} />;

export default StatTile;
